const urlSearch = new URLSearchParams(window.location.search);

const config = {};
let configInitialized = false;

export default config;

export async function initConfig() {
    if (configInitialized) {
        console.warn("initConfig() - Can't initialize config more then once");
    }

    configInitialized = true;

    Object.assign(config, __CONFIG__);

    Object.keys(config).forEach((key) => {
        if (key === 'name') {
            return;
        }

        const value = config[key];
        const valueOverride = urlSearch.get(key);

        if (valueOverride !== null) {
            if (typeof value === 'boolean') {
                config[key] = valueOverride == 'true';
            } else if (typeof value === 'number') {
                config[key] = Number(valueOverride);
            } else {
                config[key] = valueOverride;
            }
        }
    });

    Object.freeze(config);
}
